import restService from './restService'

export default {
  getActive () {
    return restService.execute('get', '/v1/admins/all')
  },
  get (id) {
    return restService.execute('get', `/v1/admins/${id}`)
  },
  create (data) {
    return restService.execute('post', '/v1/admins', { user: data })
  },
  update (id, data) {
    return restService.execute('put', `/v1/admins/${id}`, { user: data })
  },
  delete (id) {
    return restService.execute('delete', `/v1/admins/${id}`)
  },
  sendInvitation (id) {
    return restService.execute('put', `/v1/admins/${id}/invitation`)
  },
}
